import { LeftHeaderMenu } from "frontend/app-header/left-header/menu";
import { UndoRedo } from "frontend/app-header/left-header/undo-redo";
import { CursorView } from "frontend/app-header/left-header/views/cursor/cursor-view";
import { ExportView } from "frontend/app-header/left-header/views/export/export-view";
import { CanvasCIcon } from "frontend/icons/canvas-c-icon";
import { Box } from "frontend/ui-components/design-system/box/box";
import { Seperator } from "frontend/ui-components/design-system/seperator/seperator";
import styles from "./left-header.module.css";

const BoxWrapper = ({ children, padding = "0px 9px" }: { children: React.ReactNode; padding?: string }) => {
  return <div style={{ display: "flex", alignItems: "center", padding, boxShadow: "none" }}>{children}</div>;
};

export const LeftHeader = () => {
  return (
    <>
      <Box gap="0px" p="0px" direction="row" className={styles.leftHeader} alignItems="center">
        <BoxWrapper>
          <CanvasCIcon />
        </BoxWrapper>
        {/* <Seperator direction="vertical" /> */}
        {/* <CanvasName /> */}
        <Seperator direction="vertical" />
        <BoxWrapper padding="0px 4px">
          <UndoRedo />
        </BoxWrapper>
        <Seperator direction="vertical" />
        <BoxWrapper padding="0px 4px">
          <LeftHeaderMenu />
        </BoxWrapper>
      </Box>
      {/* views */}
      <ExportView />
      <CursorView />
    </>
  );
};
